class NativeHomeProducts {
  constructor(section) {
    this.section = section;
    this.grid = section.querySelector('[data-product-grid]');
    this.button = section.querySelector('[data-load-more]');
    this.status = section.querySelector('[data-product-status]');
    this.page = 1;
    this.nextProducts = [];
    this.loading = false;
    this.perPage = Number.parseInt(section.dataset.productsPerPage, 10) || 12;
    this.currency = section.dataset.currency || 'USD';

    this.button?.addEventListener('click', () => this.load());
    this.load();
  }

  async load() {
    if (this.loading || !this.grid || !this.section.dataset.productsUrl) return;

    this.loading = true;
    this.grid.setAttribute('aria-busy', 'true');
    this.button?.setAttribute('disabled', '');
    this.status.textContent = '';

    try {
      const products = this.nextProducts.length ? this.nextProducts : await this.fetchPage(this.page);
      this.nextProducts = [];
      products.forEach((product, index) => {
        const card = this.createCard(product);
        this.grid.append(card);
        window.LuckyScoopHomeMotion?.register(card, index);
      });

      if (this.page === 1 && products.length === 0) {
        if (this.section.dataset.designMode === 'true') {
          this.status.textContent = 'No Online Store products are available.';
        } else {
          this.section.hidden = true;
        }
      }

      this.page += 1;
      if (products.length === this.perPage) {
        this.nextProducts = await this.fetchPage(this.page);
      }

      if (this.nextProducts.length > 0) {
        this.button?.removeAttribute('hidden');
      } else {
        this.button?.setAttribute('hidden', '');
      }
    } catch (error) {
      this.status.textContent = this.section.dataset.errorLabel;
      this.button?.removeAttribute('hidden');
      console.error(error);
    } finally {
      this.loading = false;
      this.grid.setAttribute('aria-busy', 'false');
      this.button?.removeAttribute('disabled');
    }
  }

  async fetchPage(page) {
    const url = new URL(this.section.dataset.productsUrl, window.location.origin);
    url.searchParams.set('limit', this.perPage);
    url.searchParams.set('page', page);

    const response = await fetch(url, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error(`Products request failed: ${response.status}`);

    const data = await response.json();
    return Array.isArray(data.products) ? data.products : [];
  }

  createCard(product) {
    const card = document.createElement('a');
    card.className = 'native-home__card';
    card.href = `${window.Shopify?.routes?.root || '/'}products/${encodeURIComponent(product.handle)}`;

    const media = document.createElement('div');
    media.className = 'native-home__media';
    const imageSource = product.images?.[0]?.src;
    if (imageSource) {
      const image = document.createElement('img');
      image.src = imageSource;
      image.alt = product.images?.[0]?.alt || product.title || '';
      image.loading = 'lazy';
      image.width = 640;
      image.height = 800;
      media.append(image);
    }

    const title = document.createElement('span');
    title.className = 'native-home__product-title';
    title.textContent = product.title || '';

    const variants = Array.isArray(product.variants) ? product.variants : [];
    const available = variants.some((variant) => variant.available);
    const prices = variants.map((variant) => Number.parseFloat(variant.price)).filter(Number.isFinite);
    const currentPrice = prices.length ? Math.min(...prices) : 0;

    const price = document.createElement('span');
    price.className = 'native-home__price';
    price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: this.currency,
    }).format(currentPrice);

    card.append(media, title, price);

    if (!available) {
      const availability = document.createElement('span');
      availability.className = 'native-home__availability native-home__availability--sold-out';
      availability.textContent = this.section.dataset.soldOutLabel;
      card.append(availability);
    }
    return card;
  }
}

function initializeNativeHomeProducts(root = document) {
  root.querySelectorAll('[data-native-home-products]:not([data-products-initialized])').forEach((section) => {
    section.dataset.productsInitialized = 'true';
    new NativeHomeProducts(section);
  });
}

initializeNativeHomeProducts();
document.addEventListener('shopify:section:load', (event) => initializeNativeHomeProducts(event.target));
